import { HttpContextToken } from '@angular/common/http';

/** Public checkout requests do not use a user session or trigger token refresh. */
export const SKIP_JWT_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
